// extracted by mini-css-extract-plugin
module.exports = {"primary":"#333","white":"#fff","asideMenuWidth":"170px","headerHeight":"56px"};